import { timestampMillis } from './league-offer-week';

/**
 * tenis.io-functions offer-lifecycle-service ile aynı formül. T = maç − teklif anı:
 * yanıt süresi = min(24 sa, max(T − 6 sa, T / 2)). Uzak maçta cevap maçtan 6 saat önce belli olur;
 * yakın maçta kalan süre rakiple teklif eden arasında yarı yarıya bölünür, rakibin süresi hiç sıfırlanmaz.
 */
export const OFFER_RESPONSE_MS = 24 * 60 * 60 * 1000;
export const OFFER_PREP_MS = 6 * 60 * 60 * 1000;

export function offerResponseWindow(offeredAt: number, matchAt: number): number {
  const lead = matchAt - offeredAt;
  if (!Number.isFinite(lead) || lead <= 0) return 0;
  return Math.min(OFFER_RESPONSE_MS, Math.max(lead - OFFER_PREP_MS, lead / 2));
}

export function offerResponseDeadline(
  match: Pick<Matches.Match, 'mac_saati' | 'log_time_teklif'>,
): number {
  const matchAt = timestampMillis(match.mac_saati);
  const offeredAt = timestampMillis(match.log_time_teklif);
  // Teklif zamanı olmayan eski kayıt: önceki kural (maçtan 6 saat önce).
  if (!Number.isFinite(offeredAt)) return matchAt - OFFER_PREP_MS;
  return offeredAt + offerResponseWindow(offeredAt, matchAt);
}

/**
 * Çift lig teklifi: aynı formül. Teklif anı `log_time_teklif`, eski kayıtlarda `acilis_tarihi`
 * (tenis.io-functions `doublesOfferTiming` ile aynı).
 */
export function doublesOfferDeadline(
  match: Pick<DoublesLeagues.Match, 'mac_saati' | 'log_time_teklif' | 'acilis_tarihi'>,
): number {
  return offerResponseDeadline({
    mac_saati: match.mac_saati,
    log_time_teklif: match.log_time_teklif ?? match.acilis_tarihi,
  } as Pick<Matches.Match, 'mac_saati' | 'log_time_teklif'>);
}

/** Kalan süre; dolmuşsa null. Dakika yukarı yuvarlanır ("0 dk kaldı" gösterilmez). */
export function remainingTime(
  deadline: number,
  now: number,
): { hours: number; minutes: number } | null {
  if (!Number.isFinite(deadline) || deadline <= now) return null;
  const total = Math.ceil((deadline - now) / 60000);
  return { hours: Math.floor(total / 60), minutes: total % 60 };
}

/**
 * Teklif hâlâ yanıtlanabilir mi: bekliyor (0), kapanış işareti yok ve son yanıt anı geçmemiş.
 * Kabul bu koşulla transaction içinde yeniden denetlenir (LG-14).
 */
export function isOfferOpen(
  match: Pick<Matches.Match, 'mac_durum' | 'mac_saati' | 'log_time_teklif' | 'kapanis_nedeni'>,
  now: number,
): boolean {
  return match.mac_durum === 0 && !match.kapanis_nedeni && offerResponseDeadline(match) > now;
}
